import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend as ChartLegend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js"

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  ChartLegend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
)

export type ChartContext = { chart: ChartJS }

export const chartTextColor = "#94a3b8"
export const chartGridColor = "#e8eef5"
export const noDataLabel = "No data"

export const chartColors = {
  acknowledged: "#22d3ee",
  active: "#22c55e",
  airQuality: "#f59e0b",
  ambientSensor: "#38bdf8",
  confirmed: "#22c55e",
  cwa: "#3b82f6",
  denied: "#ef4444",
  fan: "#ef4444",
  frozen: "#cbd5e1",
  fulfilled: "#38bdf8",
  humiditySensor: "#818cf8",
  issue: "#b91c1c",
  mobileApp: "#93c5fd",
  new: "#22c55e",
  ordered: "#3b82f6",
  packed: "#7c3aed",
  pass: "#15803d",
  shipping: "#3b82f6",
  systemEfficiency: "#22c55e",
  temperatureSensor: "#a78bfa",
  thermostats: "#22d3ee",
  ths: "#7c3aed",
  wls: "#22c55e",
}

export const createGradient = (context: ChartContext, color: string) => {
  const { chart } = context
  const { ctx, chartArea } = chart

  if (!chartArea) return color

  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
  gradient.addColorStop(0, color)
  gradient.addColorStop(1, "rgba(255,255,255,0)")
  return gradient
}

export const commonChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: "rgba(15, 23, 42, 0.9)",
      borderColor: "#e2e8f0",
      borderWidth: 1,
      displayColors: true,
      padding: 8,
      titleColor: "#fff",
      bodyColor: "#fff",
    },
  },
  scales: {
    x: {
      grid: { color: chartGridColor },
      border: { display: false },
      ticks: { color: chartTextColor, font: { size: 10 } },
    },
    y: {
      beginAtZero: true,
      grid: { color: chartGridColor },
      border: { display: false },
      ticks: { color: chartTextColor, font: { size: 10 } },
    },
  },
}

export const compactLineOptions = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  scales: {
    x: { display: false, grid: { display: false }, border: { display: false } },
    y: { display: false, grid: { display: false }, border: { display: false } },
  },
}
